export const tabs = {
  edit: 'Edit',
  models: 'Models',
  dependencies: 'Dependencies',
  dimensions: 'Dimensions',
  cameras: 'Cameras',
  visibility: 'Visibility',
  groups: 'Groups',
  lights: 'Lights',
} as const
